import { useNotify, useRefresh, useRecordContext } from 'react-admin';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import PublishIcon from '@mui/icons-material/Publish';
import { request } from '../../services/request';
import { useOktaAuth } from '../../security/OktaContext';

const PREFIX = 'ApproveButton';

const classes = {
  approveButton: `${PREFIX}-approveButton`,
  approveIcon: `${PREFIX}-approveIcon`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.approveButton}`]: {
    zIndex: 3000,
    marginLeft: theme.spacing(1),
  },

  [`& .${classes.approveIcon}`]: {
    fontSize: 20,
    marginRight: theme.spacing(0.5),
  },
}));

const apiUrl = `${import.meta.env.VITE_API_URL}/v1`;

const ApproveButton = (props) => {
  const { oktaAuth } = useOktaAuth();
  const record = useRecordContext();
  const refresh = useRefresh();
  const notify = useNotify();

  const handleClick = async () => {
    const published = true;
    const updatedRecord = { ...record, published };
    const requestUrl = `${apiUrl}/queues/${record.id}`;
    const AuthorizationString = `Bearer ${oktaAuth.getAccessToken()}`;

    const requestOptions = {
      url: requestUrl,
      method: 'put',
      headers: {
        Accept: 'application/json',
        Authorization: AuthorizationString,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(updatedRecord),
    };

    try {
      await request(requestOptions);
      refresh();
      notify('Post approved', { type: 'success' });
    } catch (err) {
      notify(err.errorData.message, { type: 'warning' });
    }
  };

  return (
    <StyledButton
      color="primary"
      size="small"
      onClick={handleClick}
      className={classes.approveButton}
    >
      <PublishIcon className={classes.approveIcon} />
      Approve
    </StyledButton>
  );
};

export default ApproveButton;
